
<template>
  <div class="container-fluid">
    <div>
      <div class="row card">
        <div class="card-body" id="prof">
          <div class="d-flex align-items-center justify-content-between">
            <button
              v-if="admin.role.nom == 'DE' || hasPermission('create_decharge')"
              @click="ajouter_decharge_modal()"
              type="button"
              class="btn btn-sm bg-green text-color-green mb-3"
            >
              <span
                class="svg-size-20 svg-icon svg-icon-green svg-icon-2x mr-3"
              >
              </span>
              <span class="font-size-14 vertical-align-middle"
                >Nouvelle décharge</span
              >
            </button>
            <div class="search-zone mb-3">
              <div class="input-icon input-icon-right">
                <input
                  v-model="search"
                  type="text"
                  placeholder="Recherche ..."
                  class="w-100 form-control basic_datatable_search_query"
                />
                <span><i class="flaticon2-search-1 icon-md"></i></span>
              </div>
            </div>

            <button class="btn btn-primary" @click="exportToExcel">
              Excel
            </button>
          </div>
          <table
            ref="table"
            v-if="dechargesLoaded"
            id="dechargeTable"
            class="table"
          >
            <thead style="background-color: #003667; color: white">
              <tr class="text-center">
                <td v-if="admin.role.nom == 'VPAA' || admin.role.nom == 'VPAA'">
                  <button
                    @click="valideSelectedDecharges()"
                    type="button"
                    class="btn btn-sm bg-green text-color-green mb-3"
                  >
                    <span class="font-size-14 vertical-align-middle"
                      >Valider</span
                    >
                  </button>
                </td>
                <td v-else></td>
                <td># Agresso</td>
                <td>Matricule RH</td>
                <td>Enseignant permanent</td>
                <td>Catégorie</td>
                <td>Collège</td>
                <td
                  v-if="
                    this.admin.role.nom == 'VPAA' ||
                    this.admin.role.nom == 'DOYEN'
                  "
                >
                  <select
                    style="background-color: #003667; color: white"
                    @change="filtrer()"
                    v-model="filterEtab"
                    class="form-control"
                  >
                    <option value="" disabled selected>Établissement</option>

                    <option
                      v-for="etab in etablissements"
                      :value="etab.id"
                      :key="etab.id"
                    >
                      {{ etab.nom }}
                    </option>
                  </select>
                </td>
                <td v-else>Établissement</td>
                <td>VH statutaire</td>
                <td>VH de la décharge</td>
                <td>VH déchargé</td>
                <td>Année universitaire</td>
                <td style="max-width: 100px">Commentaire</td>
                <td style="width: 100px">
                  <select
                    style="background-color: #003667; color: white"
                    @change="filtrer()"
                    v-model="filterEtape"
                    placeholder="Etat"
                    class="form-control mr-2"
                  >
                    <option value="" disabled>Etat</option>
                    <option value="en cours">
                      En cours de validation par le doyen du collège
                    </option>
                    <option value="valide par doyen">
                      En cours de validation du VPAA
                    </option>
                    <option value="valide par VPAA">Validée</option>
                    <option value="refusee">Refusée</option>
                    <option value="--">Sans décharge</option>
                  </select>
                </td>
                <td>Date de création</td>
                <td>Date de validation du doyen</td>
                <td>Date de validation du VPAA</td>
                <td></td>
              </tr>
            </thead>
            <tbody>
              <tr
                class="text-center"
                v-for="decharge in decharges"
                :key="`vac_${decharge.id}`"
              >
                <td
                  v-if="
                    decharge.status == 'valide par doyen' &&
                    admin.role.nom == 'VPAA'
                  "
                >
                  <div class="form-inline">
                    <label class="checkbox"
                      ><input
                        type="checkbox"
                        v-model="selectedItems"
                        :value="decharge.id" />
                      <span></span
                    ></label>
                  </div>
                </td>
                <td v-else></td>
                <td>#{{ decharge.vacataire.agresso }}</td>
                <td>{{ decharge.vacataire.matricule_rh }}</td>
                <td>
                  {{ decharge.vacataire.nom }}
                  {{ decharge.vacataire.prenom }}
                </td>
                <td>{{ decharge.vacataire.categorie_prof }}</td>
                <td>{{ decharge.etablissement.college.nom }}</td>
                <td>{{ decharge.etablissement.nom }}</td>
                <td>
                  {{
                    decharge.vacataire.vh_statutaire +
                    decharge.vacataire.vh_statutaire_encad
                  }}
                  H
                </td>
                <td>{{ decharge.nb_heures }} H</td>
                <td>
                  {{
                    decharge.vacataire.vh_statutaire +
                    decharge.vacataire.vh_statutaire_encad -
                    decharge.nb_heures
                  }}
                  H
                </td>
                <td>{{ decharge.annee_universitaire }}</td>
                <td>{{ decharge.commentaire }}</td>
                <td>
                  <span
                    v-show="
                      decharge.status == 'en cours' ||
                      decharge.status == 'valide par doyen'
                    "
                    class="label label-xl label-info label-inline ml-3"
                  >
                    En cours
                  </span>
                  <span
                    v-show="decharge.status == 'valide par VPAA'"
                    class="label label-xl label-success label-inline ml-3"
                  >
                    Validée
                  </span>
                  <span
                    v-show="decharge.status == 'refusee'"
                    class="label label-xl label-danger label-inline ml-3"
                  >
                    Refusée
                  </span>
                  <span
                    v-show="decharge.status == '--'"
                    class="label label-xl label-secondary label-inline ml-3"
                  >
                    --
                  </span>
                </td>
                <td>{{ decharge.date_demande }}</td>
                <td>{{ decharge.date_validation_doyen }}</td>
                <td>{{ decharge.date_validation_VPAA }}</td>
                <td class="d-flex">
                  <button
                    v-if="
                      decharge.status == 'en cours' && admin.role.nom == 'DE'
                    "
                    @click="delete_decharge_modal(decharge)"
                    class="btn btn-outline-danger btn-sm btn-icon mr-1"
                  >
                    <i class="fa fa-trash"></i>
                  </button>
                  <button
                    v-if="
                      decharge.status == 'en cours' && admin.role.nom == 'DOYEN'
                    "
                    @click="refuse_decharge_modal(decharge)"
                    class="btn btn-outline-danger btn-sm btn-icon mr-1"
                  >
                    <i class="fa fa-times"></i>
                  </button>
                  <button
                    v-if="
                      decharge.status == 'valide par doyen' &&
                      admin.role.nom == 'VPAA'
                    "
                    @click="refuse_decharge_modal(decharge)"
                    class="btn btn-outline-danger btn-sm btn-icon mr-1"
                  >
                    <i class="fa fa-times"></i>
                  </button>
                  <button
                    v-if="
                      decharge.status == 'en cours' && admin.role.nom == 'DOYEN'
                    "
                    @click="valide_decharge_modal(decharge)"
                    class="btn btn-outline-success btn-sm btn-icon"
                  >
                    <i class="fa fa-check"></i>
                  </button>
                  <button
                    v-if="
                      decharge.status == 'valide par doyen' &&
                      admin.role.nom == 'VPAA'
                    "
                    @click="valide_decharge_modal(decharge)"
                    class="btn btn-outline-success btn-sm btn-icon"
                  >
                    <i class="fa fa-check"></i>
                  </button>
                  <button
                    v-if="
                      decharge.status == 'refusee' && admin.role.nom == 'DE'
                    "
                    @click="edit_decharge_modal(decharge)"
                    class="btn btn-outline-success btn-sm btn-icon"
                  >
                    <i class="fa fa-edit"></i>
                  </button>
                </td>
              </tr>
              <tr v-show="!decharges.length">
                <td colspan="17" class="text-center">
                  Aucune décharge trouvée.
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="16">
                  <jw-pagination
                    :items="allDecharges"
                    @changePage="onChangePagedecharge"
                  ></jw-pagination>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="delete_decharge_modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="#DeleteActivity"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content p-5">
          <form action="" method="post">
            <div class="modal-header pb-3">
              <h5 class="modal-title" id="modal_enregistrer_header">
                Supprimer décharge
              </h5>
              <button
                type="button"
                class="btn btn-sm btn-icon btn-secondary btn-circle close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <i aria-hidden="true" class="fas fa-times"></i>
              </button>
            </div>
            <div class="modal-body px-0 py-4 pb-8">
              <div class="d-flex justify-content-center">
                <h3 style="color: red">
                  Vous voulez vraiment supprimer cette décharge ?
                </h3>
              </div>
            </div>
            <div class="d-flex justify-content-between modal-footer">
              <button
                type="button"
                class="btn bg-D38686 color-FFFFFF px-16 py-3"
                data-dismiss="modal"
                aria-label="Close"
              >
                ANNULER
              </button>
              <button
                @click="delete_decharge()"
                type="button"
                class="btn btn-primary pl-10 pr-14 py-3"
              >
                <span
                  class="svg-icon svg-icon-white svg-icon-primary svg-icon-2x"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    version="1.1"
                  >
                    <g
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <polygon points="0 0 24 0 24 24 0 24" />
                      <path
                        d="M9.26193932,16.6476484 C8.90425297,17.0684559 8.27315905,17.1196257 7.85235158,16.7619393 C7.43154411,16.404253 7.38037434,15.773159 7.73806068,15.3523516 L16.2380607,5.35235158 C16.6013618,4.92493855 17.2451015,4.87991302 17.6643638,5.25259068 L22.1643638,9.25259068 C22.5771466,9.6195087 22.6143273,10.2515811 22.2474093,10.6643638 C21.8804913,11.0771466 21.2484189,11.1143273 20.8356362,10.7474093 L17.0997854,7.42665306 L9.26193932,16.6476484 Z"
                        fill="#000000"
                        fill-rule="nonzero"
                        opacity="0.3"
                        transform="translate(14.999995, 11.000002) rotate(-180.000000) translate(-14.999995, -11.000002) "
                      />
                      <path
                        d="M4.26193932,17.6476484 C3.90425297,18.0684559 3.27315905,18.1196257 2.85235158,17.7619393 C2.43154411,17.404253 2.38037434,16.773159 2.73806068,16.3523516 L11.2380607,6.35235158 C11.6013618,5.92493855 12.2451015,5.87991302 12.6643638,6.25259068 L17.1643638,10.2525907 C17.5771466,10.6195087 17.6143273,11.2515811 17.2474093,11.6643638 C16.8804913,12.0771466 16.2484189,12.1143273 15.8356362,11.7474093 L12.0997854,8.42665306 L4.26193932,17.6476484 Z"
                        fill="#000000"
                        fill-rule="nonzero"
                        transform="translate(9.999995, 12.000002) rotate(-180.000000) translate(-9.999995, -12.000002) "
                      />
                    </g>
                  </svg>
                </span>
                Supprimer
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="ajouter_decharge_modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="#ajouter_decharge_modal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content p-5">
          <div class="modal-header pb-3">
            <h5 class="modal-title" id="modal_enregistrer_header">
              Nouvelle décharge
            </h5>
            <button
              type="button"
              class="btn btn-sm btn-icon btn-secondary btn-circle close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <i aria-hidden="true" class="fas fa-times"></i>
            </button>
          </div>
          <div class="modal-body px-0 py-4 pb-8">
            <div>
              <div>
                <div class="form-group row d-flex align-items-center">
                  <label
                    style="font-size: 14px"
                    class="col-form-label col-3 text-lg-right text-left"
                    >Chercher par code EMS :</label
                  >
                  <div class="col-9 d-flex align-items-center">
                    <input
                      v-model="keyword"
                      type="text"
                      placeholder="Recherche ..."
                      class="w-100 form-control basic_datatable_search_query"
                    />
                    <button
                      class="btn btn-success ml-2"
                      :disabled="!keyword || keyword == professeur.agresso"
                      @click="getResults()"
                    >
                      Chercher
                    </button>
                  </div>
                </div>
                <hr />
                <div v-if="Object.keys(professeur).length != 0">
                  <table v-if="dechargesLoaded" class="table">
                    <thead style="background-color: #003667; color: white">
                      <tr class="text-center">
                        <td>Matricule RH</td>
                        <td>Enseignant permanent</td>
                        <td>Catégorie</td>
                        <td>VH statutaire</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class="text-center">
                        <td>{{ professeur.matricule_rh }}</td>
                        <td>
                          {{ professeur.nom }}
                          {{ professeur.prenom }}
                        </td>
                        <td>{{ professeur.categorie_prof }}</td>

                        <td>
                          {{
                            professeur.vh_statutaire +
                            professeur.vh_statutaire_encad
                          }}
                          H
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <hr />
                </div>

                <div class="form-group row">
                  <label class="col-form-label col-3 text-lg-right text-right">
                    VH de la décharge<span style="color: #ee2d41">* </span> :
                  </label>
                  <div class="col-9">
                    <div class="input-group input-group-lg input-group-solid">
                      <input
                        type="number"
                        class="form-control form-control-lg form-control-solid"
                        v-model="nb_heures"
                      />
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-form-label col-3 text-lg-right text-right">
                    Commentaire<span style="color: #ee2d41">* </span> :
                  </label>
                  <div class="col-9">
                    <textarea
                      cols="30"
                      rows="5"
                      class="form-control form-control-lg form-control-solid"
                      v-model="commentaire"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-between modal-footer">
            <button
              type="button"
              class="btn btn-danger color-FFFFFF px-16 py-3"
              data-dismiss="modal"
              aria-label="Close"
            >
              ANNULER
            </button>
            <button
              :disabled="disableValideBtn"
              @click="ajouter_decharge()"
              type="button"
              class="btn btn-primary pl-10 pr-14 py-3"
            >
              <span
                class="svg-icon svg-icon-white svg-icon-primary svg-icon-2x"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  version="1.1"
                >
                  <g
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                  >
                    <polygon points="0 0 24 0 24 24 0 24" />
                    <path
                      d="M9.26193932,16.6476484 C8.90425297,17.0684559 8.27315905,17.1196257 7.85235158,16.7619393 C7.43154411,16.404253 7.38037434,15.773159 7.73806068,15.3523516 L16.2380607,5.35235158 C16.6013618,4.92493855 17.2451015,4.87991302 17.6643638,5.25259068 L22.1643638,9.25259068 C22.5771466,9.6195087 22.6143273,10.2515811 22.2474093,10.6643638 C21.8804913,11.0771466 21.2484189,11.1143273 20.8356362,10.7474093 L17.0997854,7.42665306 L9.26193932,16.6476484 Z"
                      fill="#000000"
                      fill-rule="nonzero"
                      opacity="0.3"
                      transform="translate(14.999995, 11.000002) rotate(-180.000000) translate(-14.999995, -11.000002) "
                    />
                    <path
                      d="M4.26193932,17.6476484 C3.90425297,18.0684559 3.27315905,18.1196257 2.85235158,17.7619393 C2.43154411,17.404253 2.38037434,16.773159 2.73806068,16.3523516 L11.2380607,6.35235158 C11.6013618,5.92493855 12.2451015,5.87991302 12.6643638,6.25259068 L17.1643638,10.2525907 C17.5771466,10.6195087 17.6143273,11.2515811 17.2474093,11.6643638 C16.8804913,12.0771466 16.2484189,12.1143273 15.8356362,11.7474093 L12.0997854,8.42665306 L4.26193932,17.6476484 Z"
                      fill="#000000"
                      fill-rule="nonzero"
                      transform="translate(9.999995, 12.000002) rotate(-180.000000) translate(-9.999995, -12.000002) "
                    />
                  </g>
                </svg>
              </span>
              Valider
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="edit_decharge_modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="#edit_decharge_modal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content p-5">
          <div class="modal-header pb-3">
            <h5 class="modal-title" id="modal_enregistrer_header">
              Modifier décharge
            </h5>
            <button
              type="button"
              class="btn btn-sm btn-icon btn-secondary btn-circle close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <i aria-hidden="true" class="fas fa-times"></i>
            </button>
          </div>
          <div class="modal-body px-0 py-4 pb-8">
            <div>
              <div>
                <div v-if="Object.keys(professeur).length != 0">
                  <div class="row form-group">
                    <div
                      class="col-lg-6 d-flex align-items-center justify-content-around"
                    >
                      <div>
                        <h4
                          style="
                            color: #111b83;
                            font-size: 16px;
                            font-weight: 700;
                          "
                        >
                          {{ professeur.nom }} {{ professeur.prenom }}
                        </h4>
                      </div>
                    </div>
                    <div
                      class="col-lg-6 d-flex align-items-center justify-content-around"
                    >
                      <label class="col-form-label text-lg-right text-left">
                        Matricule RH
                      </label>
                      <label
                        style="
                          color: #b1bbcb;
                          font-size: 16px;
                          font-weight: 700;
                        "
                      >
                        {{ professeur.matricule_rh }}
                      </label>
                    </div>
                  </div>

                  <div class="row form-group d-flex justify-content-around">
                    <div
                      class="col-lg-6 d-flex align-items-center justify-content-around"
                    >
                      <label class="col-form-label text-lg-right text-left">
                        Categorie
                      </label>
                      <label
                        style="
                          color: #b1bbcb;
                          font-size: 16px;
                          font-weight: 700;
                        "
                      >
                        {{ professeur.categorie_prof }}
                      </label>
                    </div>
                    <div
                      class="col-lg-6 d-flex align-items-center justify-content-around"
                    >
                      <label class="col-form-label text-lg-right text-left">
                        VH statutaire
                      </label>
                      <label
                        style="
                          color: #b1bbcb;
                          font-size: 16px;
                          font-weight: 700;
                        "
                      >
                        {{ professeur.vh_statutaire }}
                      </label>
                    </div>
                  </div>

                  <hr />
                </div>

                <div class="form-group row">
                  <label class="col-form-label col-3 text-lg-right text-right">
                    VH de la décharge<span style="color: #ee2d41">* </span> :
                  </label>
                  <div class="col-9">
                    <div class="input-group input-group-lg input-group-solid">
                      <input
                        type="number"
                        class="form-control form-control-lg form-control-solid"
                        v-model="decharge.nb_heures"
                      />
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-form-label col-3 text-lg-right text-right">
                    Commentaire<span style="color: #ee2d41">* </span> :
                  </label>
                  <div class="col-9">
                    <textarea
                      cols="30"
                      rows="5"
                      class="form-control form-control-lg form-control-solid"
                      v-model="decharge.commentaire"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-between modal-footer">
            <button
              type="button"
              class="btn btn-danger color-FFFFFF px-16 py-3"
              data-dismiss="modal"
              aria-label="Close"
            >
              ANNULER
            </button>
            <button
              :disabled="disableValideBtn"
              @click="update_decharge()"
              type="button"
              class="btn btn-primary pl-10 pr-14 py-3"
            >
              <span
                class="svg-icon svg-icon-white svg-icon-primary svg-icon-2x"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  version="1.1"
                >
                  <g
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                  >
                    <polygon points="0 0 24 0 24 24 0 24" />
                    <path
                      d="M9.26193932,16.6476484 C8.90425297,17.0684559 8.27315905,17.1196257 7.85235158,16.7619393 C7.43154411,16.404253 7.38037434,15.773159 7.73806068,15.3523516 L16.2380607,5.35235158 C16.6013618,4.92493855 17.2451015,4.87991302 17.6643638,5.25259068 L22.1643638,9.25259068 C22.5771466,9.6195087 22.6143273,10.2515811 22.2474093,10.6643638 C21.8804913,11.0771466 21.2484189,11.1143273 20.8356362,10.7474093 L17.0997854,7.42665306 L9.26193932,16.6476484 Z"
                      fill="#000000"
                      fill-rule="nonzero"
                      opacity="0.3"
                      transform="translate(14.999995, 11.000002) rotate(-180.000000) translate(-14.999995, -11.000002) "
                    />
                    <path
                      d="M4.26193932,17.6476484 C3.90425297,18.0684559 3.27315905,18.1196257 2.85235158,17.7619393 C2.43154411,17.404253 2.38037434,16.773159 2.73806068,16.3523516 L11.2380607,6.35235158 C11.6013618,5.92493855 12.2451015,5.87991302 12.6643638,6.25259068 L17.1643638,10.2525907 C17.5771466,10.6195087 17.6143273,11.2515811 17.2474093,11.6643638 C16.8804913,12.0771466 16.2484189,12.1143273 15.8356362,11.7474093 L12.0997854,8.42665306 L4.26193932,17.6476484 Z"
                      fill="#000000"
                      fill-rule="nonzero"
                      transform="translate(9.999995, 12.000002) rotate(-180.000000) translate(-9.999995, -12.000002) "
                    />
                  </g>
                </svg>
              </span>
              Modifier
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="refuse_decharge_modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="#refuse_decharge_modal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content p-5">
          <form action="" method="post">
            <div class="modal-header pb-3">
              <h5 class="modal-title" id="modal_enregistrer_header">
                Refus de la décharge
              </h5>
              <button
                type="button"
                class="btn btn-sm btn-icon btn-secondary btn-circle close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <i aria-hidden="true" class="fas fa-times"></i>
              </button>
            </div>
            <div class="modal-body px-0 py-4 pb-8">
              <div class="row">
                <label
                  style="
                    color: rgb(17, 27, 131);
                    font-size: 16px;
                    font-weight: 700;
                  "
                  class="col-form-label col-3 text-lg"
                  >Motif<span style="color: #ee2d41">* </span> :</label
                >
              </div>
              <div class="d-flex justify-content-center">
                <textarea
                  v-model="justife"
                  rows="5"
                  class="form-control"
                ></textarea>
              </div>
            </div>
            <div class="d-flex justify-content-between modal-footer">
              <button
                type="button"
                class="btn bg-D38686 color-FFFFFF px-16 py-3"
                data-dismiss="modal"
                aria-label="Close"
              >
                ANNULER
              </button>
              <button
                :disabled="this.justife == null || this.justife == ''"
                @click="refuse_decharge()"
                type="button"
                class="btn btn-primary pl-10 pr-14 py-3"
              >
                <span
                  class="svg-icon svg-icon-white svg-icon-primary svg-icon-2x"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    version="1.1"
                  >
                    <g
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <polygon points="0 0 24 0 24 24 0 24" />
                      <path
                        d="M9.26193932,16.6476484 C8.90425297,17.0684559 8.27315905,17.1196257 7.85235158,16.7619393 C7.43154411,16.404253 7.38037434,15.773159 7.73806068,15.3523516 L16.2380607,5.35235158 C16.6013618,4.92493855 17.2451015,4.87991302 17.6643638,5.25259068 L22.1643638,9.25259068 C22.5771466,9.6195087 22.6143273,10.2515811 22.2474093,10.6643638 C21.8804913,11.0771466 21.2484189,11.1143273 20.8356362,10.7474093 L17.0997854,7.42665306 L9.26193932,16.6476484 Z"
                        fill="#000000"
                        fill-rule="nonzero"
                        opacity="0.3"
                        transform="translate(14.999995, 11.000002) rotate(-180.000000) translate(-14.999995, -11.000002) "
                      />
                      <path
                        d="M4.26193932,17.6476484 C3.90425297,18.0684559 3.27315905,18.1196257 2.85235158,17.7619393 C2.43154411,17.404253 2.38037434,16.773159 2.73806068,16.3523516 L11.2380607,6.35235158 C11.6013618,5.92493855 12.2451015,5.87991302 12.6643638,6.25259068 L17.1643638,10.2525907 C17.5771466,10.6195087 17.6143273,11.2515811 17.2474093,11.6643638 C16.8804913,12.0771466 16.2484189,12.1143273 15.8356362,11.7474093 L12.0997854,8.42665306 L4.26193932,17.6476484 Z"
                        fill="#000000"
                        fill-rule="nonzero"
                        transform="translate(9.999995, 12.000002) rotate(-180.000000) translate(-9.999995, -12.000002) "
                      />
                    </g>
                  </svg>
                </span>
                Refuser
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="valide_decharge_modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="#Validedecharge"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content p-5">
          <form action="" method="post">
            <div class="modal-header pb-3">
              <h5
                v-if="admin.role.nom == 'VPAA'"
                class="modal-title"
                id="modal_enregistrer_header"
              >
                Approbation de la décharge
              </h5>
              <h5 v-else class="modal-title" id="modal_enregistrer_header">
                Validation de la décharge
              </h5>

              <button
                type="button"
                class="btn btn-sm btn-icon btn-secondary btn-circle close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <i aria-hidden="true" class="fas fa-times"></i>
              </button>
            </div>
            <div class="modal-body px-0 py-4 pb-8">
              <div class="row form-group text-center">
                <div
                  class="col-lg-12 d-flex align-items-center justify-content-around"
                >
                  <div>
                    <h4
                      style="color: #111b83; font-size: 16px; font-weight: 700"
                    >
                      {{ professeur.nom }} {{ professeur.prenom }}
                    </h4>
                    <label
                      style="color: #b1bbcb; font-size: 16px; font-weight: 700"
                    >
                      {{ professeur.categorie_prof }}
                    </label>
                  </div>
                </div>
              </div>

              <div class="row form-group d-flex justify-content-around">
                <div
                  class="col-lg-6 d-flex align-items-center justify-content-around"
                >
                  <label class="col-form-label text-lg-right text-left">
                    VH statutaire :
                  </label>
                  <label
                    style="color: #b1bbcb; font-size: 16px; font-weight: 700"
                  >
                    {{ professeur.vh_statutaire }}
                  </label>
                </div>
                <div
                  class="col-lg-6 d-flex align-items-center justify-content-around"
                >
                  <label class="col-form-label text-lg-right text-left">
                    VH de la décharge :
                  </label>
                  <label
                    style="color: #b1bbcb; font-size: 16px; font-weight: 700"
                  >
                    {{ decharge.nb_heures }}
                  </label>
                </div>
              </div>
              <div class="row form-group d-flex justify-content-around">
                <div
                  class="col-lg-12 d-flex align-items-center justify-content-center"
                >
                  <label class="mr-5"> Commentaire : </label>
                  <label style="font-size: 14px; color: black">
                    {{ decharge.commentaire }}
                  </label>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-between modal-footer">
              <button
                type="button"
                class="btn bg-danger color-FFFFFF px-16 py-3"
                data-dismiss="modal"
                aria-label="Close"
              >
                ANNULER
              </button>
              <button
                @click="valide_decharge()"
                type="button"
                class="btn btn-primary pl-10 pr-14 py-3"
              >
                <span
                  class="svg-icon svg-icon-white svg-icon-primary svg-icon-2x"
                >
                  <span class="svg-icon svg-icon-success svg-icon-2x">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      width="24px"
                      height="24px"
                      viewBox="0 0 24 24"
                      version="1.1"
                    >
                      <g
                        stroke="none"
                        stroke-width="1"
                        fill="none"
                        fill-rule="evenodd"
                      >
                        <polygon points="0 0 24 0 24 24 0 24" />
                        <path
                          d="M6.26193932,17.6476484 C5.90425297,18.0684559 5.27315905,18.1196257 4.85235158,17.7619393 C4.43154411,17.404253 4.38037434,16.773159 4.73806068,16.3523516 L13.2380607,6.35235158 C13.6013618,5.92493855 14.2451015,5.87991302 14.6643638,6.25259068 L19.1643638,10.2525907 C19.5771466,10.6195087 19.6143273,11.2515811 19.2474093,11.6643638 C18.8804913,12.0771466 18.2484189,12.1143273 17.8356362,11.7474093 L14.0997854,8.42665306 L6.26193932,17.6476484 Z"
                          fill="#000000"
                          fill-rule="nonzero"
                          transform="translate(11.999995, 12.000002) rotate(-180.000000) translate(-11.999995, -12.000002) "
                        />
                      </g>
                    </svg>
                  </span>
                </span>
                Valider
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VclTable } from "vue-content-loading";
import * as XLSX from "xlsx";
import moment from "moment";

export default {
  props: {
    admin: {},
  },
  components: {
    VclTable,
  },
  data() {
    return {
      allDecharges: [],
      prof: [],
      decharges: [],
      decharge: {},
      vacataire: [],
      professeur: {},
      profLoaded: null,
      dechargesLoaded: null,
      keyword: null,
      search: null,
      nb_heures_old: null,
      nb_heures: null,
      type: "",
      commentaire: null,
      justife: null,
      profNotFound: false,
      disableValideBtn: false,
      selectedItems: [],
      currentDateTime: moment().format("YYYY-MM-DD"),
      filterEtape: "",
      filterEtab: "",

      config: {
        headers: {
          Authorization: "Bearer " + this.admin.api_token,
        },
      },
    };
  },
  watch: {
    search(after, before) {
      if (this.search != "") {
        this.searchDecharges();
      } else {
        this.reloaddecharges();
      }
    },
  },

  methods: {
    hasPermission(code) {
      return this.admin.permissions.some(
        (permission) => permission.code === code
      );
    },
    filtrer() {
      axios
        .post(
          "/api/filter/decharges",
          {
            admin_id: this.admin.id,
            etape: this.filterEtape,
            etablissement_id: this.filterEtab,
          },
          this.config
        )
        .then((res) => {
          this.allDecharges = res.data;
          this.dechargesLoaded = 1;
        });
    },
    /* filtrerEtab() {
      axios
        .post(
          "/api/filter/decharges",
          {
            admin_id: this.admin.id,
            etablissement_id: this.filterEtab,
          },
          this.config
        )
        .then((res) => {
          this.allDecharges = res.data;
          this.dechargesLoaded = 1;
        });
    }, */
    exportToExcel() {
      // Map data: remove 'email', and map 'role' to 'role.name'
      const exportData = this.allDecharges.map((decharge) => ({
        Agresso: decharge.vacataire.agresso,
        "Matricule RH": decharge.vacataire.matricule_rh,
        "Enseignant permanent":
          decharge.vacataire.nom + " " + decharge.vacataire.prenom,
        Catégorie: decharge.vacataire.categorie_prof,
        Collège: decharge.etablissement
          ? decharge.etablissement.college.nom
          : "--",
        Établissement: decharge.etablissement
          ? decharge.etablissement.nom
          : "--",
        "VH statutaire":
          decharge.vacataire.vh_statutaire +
          decharge.vacataire.vh_statutaire_encad,
        "VH de la décharge": decharge.nb_heures,
        "VH déchargé":
          decharge.vacataire.vh_statutaire +
          decharge.vacataire.vh_statutaire_encad -
          decharge.nb_heures,
        "Année universitaire": decharge.annee_universitaire,
        Commentaire: decharge.commentaire,
        Etat: this.formatStatus(decharge.status),
        "Date de création": decharge.date_demande,
        "Date de validation du doyen": decharge.date_validation_doyen,
        "Date de validation du VPAA": decharge.date_validation_VPAA,
      }));

      // Convert to worksheet and export
      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Decharges");
      XLSX.writeFile(workbook, "DÉCHARGES_" + this.currentDateTime + ".xlsx");
    },
    formatStatus(status) {
      if (status === "en cours") return "Créée par le directeur";
      if (status === "valide par doyen") return "Validée par le doyen";
      if (status === "valide par VPAA") return "Validée";
      if (status === "refusee") return "Refusée";
      return status;
    },
    valideSelectedDecharges() {
      if (this.selectedItems.length != 0) {
        axios
          .post(
            "/api/decharge/valideSelected",
            {
              decharges_id: this.selectedItems,
            },
            this.config
          )
          .then((response) => {
            this.reloaddecharges();
            this.selectedItems = [];
            Vue.swal.fire({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              title: "Décharges validées",
              icon: "success",
              confirmButtonText: "Cool",
            });
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        Vue.swal.fire({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 5000,
          title: "Veuillez sélectionner au moins une décharge pour valider.",
          icon: "error",
          confirmButtonText: "Cool",
        });
      }
    },
    ajouter_decharge() {
      if (this.nb_heures > this.professeur.vh_statutaire) {
        Vue.swal.fire({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 5000,
          title:
            "Veuillez ne pas dépasser le volume horaire statutaire du professeur.",
          icon: "error",
          confirmButtonText: "Cool",
        });
      } else if (this.nb_heures <= 0) {
        Vue.swal.fire({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 5000,
          title: "Le nombre d'heures doit être supérieur de 0",
          icon: "error",
          confirmButtonText: "Cool",
        });
      } else if (this.commentaire == null || this.commentaire == "") {
        Vue.swal.fire({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 5000,
          title: "Le champ commentaire est obligatoire",
          icon: "error",
          confirmButtonText: "Cool",
        });
      } else if (this.nb_heures > 0) {
        axios
          .post(
            "/api/prof/decharge/" + this.professeur.id,
            {
              nb_heures: this.nb_heures,
              commentaire: this.commentaire,
            },
            this.config
          )
          .then((res) => {
            this.nb_heures_old = this.professeur.nb_heures;
            this.professeur = {};
            this.nb_heures = null;
            this.keyword = null;
            this.commentaire = "";
            this.reloaddecharges();

            $("#ajouter_decharge_modal").modal("hide");
            this.decharge = {};

            Vue.swal.fire({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
              title: "Décharge ajoutée avec succès",
              icon: "success",
              confirmButtonText: "Cool",
            });
          })
          .catch((error) => {
            this.nb_heures_old = this.professeur.nb_heures;
            this.professeur = {};
            this.nb_heures = null;
            this.keyword = null;
            this.commentaire = "";
            this.reloaddecharges();

            $("#ajouter_decharge_modal").modal("hide");
            this.decharge = {};

            let message = "Erreur dans l'ajout du déchargé";
            if (error.response && error.response.data.message) {
              message = error.response.data.message;
            }

            Vue.swal.fire({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 50000,
              title: message,
              icon: "error",
              confirmButtonText: "Cool",
            });
          });
      }
    },
    getResults() {
      axios
        .get("/api/search/prof/" + this.keyword, this.config)
        .then((res) => {
          this.professeur = res.data;

          if (Object.keys(this.professeur).length === 0) {
            this.profNotFound = true;
            this.disableValideBtn = true;
          } else {
            this.profNotFound = false;
            this.disableValideBtn = false;
          }
        })
        .catch((error) => {
          let message = "Erreur";
          if (error.response && error.response.data.message) {
            message = error.response.data.message;
          }

          Vue.swal.fire({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 20000,
            title: message,
            icon: "error",
            confirmButtonText: "Cool",
          });
        });
    },
    onChangePage(prof) {
      // update page of items
      this.prof = prof;
    },
    onChangePagedecharge(decharges) {
      // update page of items
      this.decharges = decharges;
    },

    reloaddecharges() {
      axios
        .get("/api/get/decharges/" + this.admin.id, this.config)
        .then((res) => {
          this.allDecharges = res.data;
          this.dechargesLoaded = 1;
        });
    },

    searchDecharges() {
      axios
        .get(
          "/api/search/decharges/" + this.admin.id + "/" + this.search,
          this.config
        )
        .then((res) => (this.decharges = res.data))
        .catch((error) => {});
    },

    delete_decharge_modal(decharge) {
      this.decharge = decharge;
      $("#delete_decharge_modal").modal("show");
    },

    ajouter_decharge_modal() {
      $("#ajouter_decharge_modal").modal("show");

      if (Object.keys(this.professeur).length === 0) {
        this.disableValideBtn = true;
      } else {
        this.disableValideBtn = false;
      }
    },

    edit_decharge_modal(decharge) {
      this.professeur = decharge.vacataire;
      this.decharge = decharge;
      $("#edit_decharge_modal").modal("show");
    },

    update_decharge() {
      if (this.decharge.nb_heures > this.professeur.vh_statutaire) {
        Vue.swal.fire({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 5000,
          title:
            "Veuillez ne pas dépasser le volume horaire statutaire du professeur.",
          icon: "error",
          confirmButtonText: "Cool",
        });
      } else if (this.decharge.nb_heures <= 0) {
        Vue.swal.fire({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 5000,
          title: "Le nombre d'heures doit être supérieur de 0",
          icon: "error",
          confirmButtonText: "Cool",
        });
      } else if (
        this.decharge.commentaire == null ||
        this.decharge.commentaire == ""
      ) {
        Vue.swal.fire({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 5000,
          title: "Le champ commentaire est obligatoire",
          icon: "error",
          confirmButtonText: "Cool",
        });
      } else if (this.decharge.nb_heures > 0) {
        axios
          .post(
            "/api/update/decharge/" + this.decharge.id,
            {
              nb_heures: this.decharge.nb_heures,
              commentaire: this.decharge.commentaire,
            },
            this.config
          )
          .then((res) => {
            this.nb_heures_old = this.professeur.nb_heures;
            this.professeur = {};
            this.nb_heures = null;
            this.keyword = null;
            this.commentaire = "";
            this.reloaddecharges();

            $("#edit_decharge_modal").modal("hide");
            this.decharge = {};

            Vue.swal.fire({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
              title: "Décharge modifiée avec succès",
              icon: "success",
              confirmButtonText: "Cool",
            });
          })
          .catch((error) => {
            this.nb_heures_old = this.professeur.nb_heures;
            this.professeur = {};
            this.nb_heures = null;
            this.keyword = null;
            this.commentaire = "";
            this.reloaddecharges();

            $("#edit_decharge_modal").modal("hide");
            this.decharge = {};

            let message = "Erreur dans la modification du déchargé";
            if (error.response && error.response.data.message) {
              message = error.response.data.message;
            }

            Vue.swal.fire({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 50000,
              title: message,
              icon: "error",
              confirmButtonText: "Cool",
            });
          });
      }
    },

    delete_decharge() {
      axios
        .delete("/api/decharge/delete/" + this.decharge.id, this.config)
        .then((response) => {
          $("#delete_decharge_modal").modal("hide");
          this.decharge = {};
          this.reloaddecharges();

          Vue.swal.fire({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            title: "Décharge supprimée !",
            icon: "success",
            confirmButtonText: "Cool",
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    valide_decharge_modal(decharge) {
      this.decharge = decharge;
      this.professeur = decharge.vacataire;
      $("#valide_decharge_modal").modal("show");
    },

    valide_decharge() {
      axios
        .put(
          "/api/decharge/valide/" + this.decharge.id + "/" + this.admin.id,
          {},
          this.config
        )
        .then((response) => {
          $("#valide_decharge_modal").modal("hide");
          this.decharge = {};
          this.reloaddecharges();

          Vue.swal.fire({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            title: "Décharge validée",
            icon: "success",
            confirmButtonText: "Cool",
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    refuse_decharge_modal(decharge) {
      this.decharge = decharge;
      $("#refuse_decharge_modal").modal("show");
    },

    refuse_decharge() {
      axios
        .put(
          "/api/decharge/refuse/" + this.decharge.id + "/" + this.admin.id,
          {
            justife: this.justife,
          },
          this.config
        )
        .then((response) => {
          $("#refuse_decharge_modal").modal("hide");
          this.decharge = {};
          this.reloaddecharges();

          Vue.swal.fire({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            title: "Décharge refusée",
            icon: "success",
            confirmButtonText: "Cool",
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  beforeMount() {
    axios
      .get("/api/get/decharges/" + this.admin.id, this.config)
      .then((res) => {
        this.allDecharges = res.data;
        this.dechargesLoaded = 1;
      });

    axios.get("/api/get/etablissements", this.config).then((res) => {
      this.etablissements = res.data;
    });
  },
};
</script>
